// For a button to open the booking widget, its anchor href must be exactly "#book-now".
(function (a) {
    var b = {
        businessId: 'dc773a6c-b9b0-4ffc-8ad8-d52f18df3bc5',
        gaMeasurementId: 'G-905X9DJQQW',
    };
  
    var c = a.createElement('script');
    var d = a.querySelector('script');
  
    c.src = 'https://static.joinboulevard.com/injector.min.js';
    c.async = true;
    c.onload = function () {
        blvd.init(b);
    };
  
    d.parentNode.insertBefore(c, d);
})(document);
